import IConfigurationModel from "@/models/configuration-model";
import * as LinkConstants from '@/constants/link-constants'
import * as UrlConstants from '@/constants/url-constants'
import SentrySingleton from "@/singletons/sentry-singleton";

export default class LinkGeneratorService {
    createCopyLink(config: IConfigurationModel, fullorder: boolean, renderingmode: boolean): string {
        try {
            let builder = this.createLinkBuilder(config, fullorder, "fullorder.html")
            this.addRenderingMode(builder, renderingmode)
            return builder.join('')
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return ''
        }
    }

    createQrcodeLink(config: IConfigurationModel, fullorder: boolean): string {
        try {
            let builder = this.createLinkBuilder(config, fullorder, "vieworder.html")
            return builder.join('')
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return ''
        }
    }

    private createLinkBuilder(config: IConfigurationModel, fullorder: boolean, page: string) {
        let builder = [] as Array<string>
        builder.push(LinkConstants.prodURL)
        builder.push(page)
        builder.push('?')
        builder.push(this.buildUrlParameterLink(config))
        this.addFullorder(builder, fullorder)
        return builder
    }

    private buildUrlParameterLink(config: IConfigurationModel): string {
        let builder = [] as Array<string>
        this.addStringParameter(builder, config.bagsize, UrlConstants.bagsize);
        this.addStringParameter(builder, config.body, UrlConstants.body);
        this.addStringParameter(builder, config.edge, UrlConstants.edge);
        this.addStringParameter(builder, config.thread, UrlConstants.thread);
        this.addStringParameter(builder, config.inside, UrlConstants.inside);
        this.addStringParameter(builder, config.pocket, UrlConstants.pocket);
        this.addStringParameter(builder, config.side, UrlConstants.side);
        this.addStringParameter(builder, config.front, UrlConstants.front);
        this.addStringParameter(builder, config.tack, UrlConstants.tack);
        this.addStringParameter(builder, config.back, UrlConstants.back);
        this.addStringParameter(builder, encodeURIComponent(config.namechar ?? ""), UrlConstants.namechar);
        this.addStringParameter(builder, config.namethread, UrlConstants.namethread);
        this.addStringParameter(builder, config.noName, UrlConstants.noName);
        return builder.join('&')
    }

    private addStringParameter(parameters: Array<string>, option: string | null, param: string) {
        if (option && option.length > 0) {
            parameters.push(param + "=" + option);
        }
    }

    private addFullorder(builder: Array<string>, fullorder: boolean) {
        if (fullorder) {
            builder.push("&" + UrlConstants.fullorder + "=true");
        }
    }

    private addRenderingMode(builder: Array<string>, renderingmode: boolean) {
        builder.push("&" + UrlConstants.renderingmode + "=" + renderingmode);
    }
}